import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { FullScreenModals, WebDesigns } from '../../../../../utils/Constant'
import { fullScreenData } from '../../../../../Data/Ui-Kits/Modal/Modal'
import { Fragment, useState } from 'react'
import { ChevronsRight } from 'react-feather'
import { Btn, H6, P } from '../../../../../AbstractElements'

const FullScreenModal = () => {
  const [fullScreen, setFullScreen] = useState<boolean>(false);
  const fullScreenToggle = () => setFullScreen(!fullScreen);
  return (
    <>
      <Btn color="secondary" onClick={fullScreenToggle}>{FullScreenModals}</Btn>
      <Modal fullscreen isOpen={fullScreen} toggle={fullScreenToggle}>
        <ModalHeader toggle={fullScreenToggle}>{FullScreenModals}</ModalHeader>
        <ModalBody className="dark-modal">
        <div className="large-modal-header"><ChevronsRight />
          <H6>{WebDesigns} </H6>
        </div>
        <P className="modal-padding-space">We build specialised websites for companies, list them on digital directories, and set up a sales funnel to boost ROI.</P>
        {fullScreenData.map(({ title, text }, index) => (
          <Fragment key={index}>
            <div className="large-modal-header">
              <ChevronsRight />
              <H6>{title}</H6>
            </div>
            <P className="modal-padding-space">{text}</P>
          </Fragment>
        ))}
        </ModalBody>
      </Modal>
    </>
  )
}

export default FullScreenModal